import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import { langPath } from '../../utils/langPath';

const ProtectedRoute = ({ children }) => {
    const { user } = useAuth();
    const location = useLocation();
    const { language } = useLanguage();

    if (!user) {
        // Redirect to the login page, but save the current location they were trying to go to
        return <Navigate to={langPath('/login', language)} state={{ from: location }} replace />;
    }

    // Profile completion is now deferred to purchase time (SubscriptionModal)
    // Users can browse free content without completing their profile

    return children;
};

export default ProtectedRoute;
